const YouAreI = require('youarei')
const _ = require('underscore')
const angular = require('angular')

import { devEnvironment, stagingEnvironment } from './lib/utils'

require('../css/reset.css')
require('../css/grid.css')
//require 'animate.css/animate.css'
require('../css/grid-extensions.styl')
require('../css/leaf.styl')
require('../css/forms.styl')
require('../css/type.styl')

require('../css/layout.styl')
require('../css/main.styl')
require('../css/spinner.styl')
require('../css/images.styl')
import icons from '../../build/icons.svgi'

const cssLoaded = []
if (window.jQuery) {
  console.log('jQuery seems to be present inside the widget. this is bad')
}

const breakpoints = [
  [400, 'xs'],
  [650, 'sm'],
  [934, 'md'],
]

const setBreakpoint = function (el, config, lastbp) {
  if (el[0].offsetWidth === 0) {
    return
  }
  const bp =
    _guard(
      _.find(breakpoints, (a) => el[0].offsetWidth < a[0]),
      (x) => x[1],
    ) || 'lg'

  if (bp !== lastbp) {
    lastbp = bp
    config.detectedBreakpoint = bp
    el.removeClass('x-al-xs x-al-sm x-al-md x-al-lg')
    return el.addClass(`x-al-${bp}`)
  }
}

const loadCSS = function (url, target, config) {
  //generate a prefix, using data info or uri
  //ns is data-target or our host
  const base = new YouAreI(url)

  base.query_set({
    domain: target.host(),
    style_palette: config.palette,
    style_font_family_base: config.styleFontFamilyBase,
    style_font_size_base: config.styleFontSizeBase,
  })

  url = base.to_string()
  if (cssLoaded[url]) {
    return
  }

  if (document.createStyleSheet) {
    document.createStyleSheet(url)
  } else {
    const link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.href = url
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  return (cssLoaded[url] = true)
}

const configFromHash = function (yri) {
  let hash
  if ((hash = yri.fragment())) {
    let json
    const decoded = decodeURIComponent(hash).substring(1)
    try {
      json = JSON.parse(decoded)
    } catch (error) {
      return {}
    }

    if (json.options) {
      return json.options
    }
  }
  return {}
}

const is_touch_device = () => Array.from(window).includes('ontouchstart') || Array.from(window).includes('onmsgesturechange')

const getWidgetNameAndElement = (allocateElement) => {
  const wel = angular.element(allocateElement)
  if (wel.hasClass('_allocate-loaded')) {
    return
  } // already loaded

  wel.addClass('_allocate-loaded')
  const wrapper = angular.element('<section id="_xa"><section id="_xaw"><div></div></section></section>')
  const inner = wrapper.find('div')
  wel.append(wrapper)

  let widgetName = wel.attr('data-allocate-widget')
  if (widgetName === 'booking' && window.location.hash.indexOf('unpaidBooking') !== -1) {
    widgetName = 'unpaid-booking'
  }
  if (!widgetName) {
    throw new Error("You didn't define a widget to load with data-allocate-widget='widget-name'")
  }
  return { widgetName, widgetElement: inner }
}

angular.element(document).ready(function () {
  //insert svg into document head
  const svgc = document.createElement('div')
  svgc.setAttribute('style', 'display: none')
  svgc.innerHTML = icons
  document.getElementsByTagName('body')[0].appendChild(svgc)

  return _loadWidgets()
})

var _loadWidgets = function () {
  const uri = new YouAreI(window.location.href)
  return angular.forEach(document.querySelectorAll('._allocate'), function (element) {
    const { widgetName, widgetElement } = getWidgetNameAndElement(element)

    // Require the widget's module (this will cause it to load its
    // controller into angular)
    return require.ensure(
      [],
      function () {
        let widget = require(`./widgets/${widgetName}`)

        // Take all the data-angular- attributes on the widget and put
        // them into a config variable which is made available via
        // Angular's DI
        const config = {
          touchDevice: is_touch_device(),
        }
        for (var { name, value } of Array.from(element.attributes)) {
          const allocatePropRe = /^data-allocate-(.*)/
          const m = name.match(allocatePropRe)
          if (m) {
            // Remove the prefix and transform into camel case
            let jsName = m[1].split('-')
            jsName =
              jsName[0] +
              Array.from(jsName.slice(1))
                .map((s) => s[0].toUpperCase() + s.slice(1))
                .join('')
            if (value === 'true') {
              value = true
            }
            if (value === 'false') {
              value = false
            }
            config[jsName] = value
          }
        }

        //override any config settings with config in hash
        _.defaults(config, configFromHash(uri))

        const remapOld = {
          limit_id: 'limitZoneId',
          limit_rooms: 'limitZoneId',
        }

        for (let qname of [
          'limit_id',
          'limit_rooms',
          'limitZoneId',
          'limitProductId',
          'limitProductType',
          'limitZoneType',
          'maxRooms',
          'palette',
          'target',
          'availabilityMode',
          'skipSingleOptions',
          'showFirst',
          'separateView',
          'showUnavailable',
          'showAlternate',
        ]) {
          var opt
          if ((opt = uri.query_get(qname))) {
            name = remapOld[qname] || qname
            config[name] = opt
          }
        }

        //TODO: check whether multiple same id's *actually* breaks stuff or
        //whether we can cheat and make our styles have a higher priority without
        //resorting to !important

        //check we are SSL or in dev otherwise disable payment
        if (config.paymentDisabled == null && uri.scheme() !== 'https' && !__DEV__) {
          config.paymentDisabled = true
        }

        if (config.paymentDisabled === 'false') {
          config.paymentDisabled = false
        }

        config.target = new YouAreI(config.target || window.location.hostname)

        //TODO deprecate.
        if (config.secureTarget) {
          config.secureTarget = new YouAreI(config.secureTarget)
        } else {
          config.secureTarget = new YouAreI('https://hosted.allocate.co.uk/simple/')
          config.secureTarget.query_merge({
            target: config.target.toString(),
          })
        }

        if (config.bookingTarget) {
          const tg = new YouAreI(config.bookingTarget)
          if (tg.scheme() === 'https') {
            config.bookingTarget = tg
            //replaces secure target.
            config.secureTarget = tg
          }
        }

        widget.value('allocateWidgetConfig', config)

        let apiHost = 'https://api.allocate.co.uk'
        if (devEnvironment()) {
          apiHost = 'http://local.allocate.co.uk:8000'
        } else if (stagingEnvironment()) {
          apiHost = 'https://api.preview.allocate.co.uk'
        }

        loadCSS(`${apiHost}/api/v3/bookingWidgets/palette.css`, config.target, config)
        const lastbp = null
        setBreakpoint(widgetElement, config, lastbp)
        window.onresize = _.debounce(() => setBreakpoint(widgetElement, config, lastbp), 100)

        // Create a service that attaches a template to the widget
        // container (to be used, once, from the widget's module)
        widget.factory('allocateAttachWidget', [
          '$compile',
          '$rootScope',
          ($compile, $rootScope) => (template) =>
            //defer to avoid instantiating multiple times
            _.defer(function () {
              const scope = $rootScope.$new()
              const link = $compile(template)
              return link(scope, (el) => widgetElement[0].appendChild(el[0]))
            }),
        ])

        // Start up the angular machinery
        return (widget = angular.bootstrap(element, [widget.name]))
      },
      'widgets',
    )
  })
}

// Allow widgets to be initialised at a later point of time.
// Exposes a property on the `window` so that the host page can call this
// function to get allocate to render any widgets that have just been added to
// the page.
if (!window.refreshAllocateWidgets) {
  window.refreshAllocateWidgets = () => _loadWidgets()
}

function _guard(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined
}
